<template>
  <div v-if="shown" class="alert alert-dismissable api-warning">
    <img src="/img/ic_info.svg" alt="">
    <p>
      <slot></slot>
    </p>
    <reset-button @click.once="close" class="close" />
  </div>
</template>

<script>
export default {
  name: 'alert',
  props: {
    storageKey: {
      type: String,
      require: true
    }
  },
  data: () => ({
    shown: true
  }),
  created () {
    const shown = parseInt(localStorage.getItem(this.storageKey))
    if (!isNaN(shown) && !shown) {
      this.shown = false
    }
  },
  methods: {
    close () {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
      localStorage.setItem(this.storageKey, 0)
    }
  }
}
</script>